import { createSlice } from "@reduxjs/toolkit";
const initialState = [
  {
    name: "Search",
    show: false,
  },
  {
    name: "Navigation",
    show: false,
  },
  {
    name: "Proximity",
    show: false,
  },
  {
    name: "Aoi",
    show: false,
  },
  {
    name: "Filter",
    show: false,
  },
  {
    name: "Measure",
    show: false,
  },
];

const toolsSlice = createSlice({

  name: "tools",
  initialState,
  reducers: {
    setTools: (state, action) => {
      state.map((st) => {
        st.name === action.payload.name ? (st.show = true) : (st.show = false);
      });
    },
    closeTools: (state, action) => {
      state.map((st) => {
        st.show = false;
      });
    }
  },
});

export const { setTools,closeTools } = toolsSlice.actions;

export const selectTools = (state) => state.tools;

export default toolsSlice.reducer;
